import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

interface IOffersCountLinkProps {
  expanded: boolean;
  count: number;
  onClick: () => void;
}

export const OffersCountLink: React.FC<IOffersCountLinkProps> = ({ count, expanded, onClick }) => {
  return (
    <div onClick={onClick} role="button" className={styles['container']} data-testid="OffersCountLink">
      {expanded ? (
        <>
          <ArticleParagraph1 color="text-main-default">Скрыть {count} предложений</ArticleParagraph1>
          <span className={styles['arrow']}>
            <IconActionChevronUpSmall16 color="icon-main-default" />
          </span>
        </>
      ) : (
        <>
          <ArticleParagraph1 color="text-main-default">Показать еще {count} предложений</ArticleParagraph1>
          <span className={styles['arrow']}>
            <IconActionChevronDownSmall16 color="icon-main-default" />
          </span>
        </>
      )}
    </div>
  );
};
